const {
  eachWeekOfInterval,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  startOfISOWeek,
  endOfISOWeek,
  isSameMonth,
  eachMonthOfInterval,
  add,
  format,
} = require("date-fns");

window.addEventListener("turbo:load", () => {
  const customTime = document.querySelector("#custom-clock");
  const checkbox = document.querySelectorAll(".form-checkbox");
  const options = {
    hours: getNumberMatrix(Array.from(range(0, 23, 1))),
    minutes: getNumberMatrix(Array.from(range(0, 55, 5))),
    days: getNumberMatrix(Array.from(range(1, 30, 1))),
  };
  const customCalendar = document.querySelectorAll(".custom-calendar");

  const currentYear = new Date().getFullYear();
  const monthsAhead = eachMonthOfInterval({
    start: new Date(currentYear, 0, 1),
    end: add(new Date(currentYear, 0, 1), {
      months: 11,
    }),
  });

  const months = monthsAhead.map((month) => ({
    long: format(month, "MMMM"),
    short: format(month, "MMM"),
  }));

  const monthArray = monthsAhead.map((month) => {
    return {
      year: month.getFullYear(),
      weeksArray: getMountMatrix(
        {
          year: month.getFullYear(),
          mount: month.getMonth(),
        },
        (date, { isSameMonth: sameMonth }) => {
          return sameMonth && date > new Date()
            ? {
                disabled: false,
                number: format(date, "dd"),
                date: format(date, "yyyy.MM.dd"),
              }
            : {
                disabled: true,
                number: format(date, "dd"),
                date: format(date, "yyyy.MM.dd"),
              };
        }
      ),
    };
  });

  if (checkbox.length) {
    checkbox.forEach((ch) => {
      const fieldTime =
      ch.parentElement.parentElement.querySelector(
        ".form-field-time"
      );
      if (ch.checked) {
        fieldTime.classList.add("hidden");
      } else {
        fieldTime.classList.remove("hidden");
      }
      ch.addEventListener("change", (el) => {
        const fieldTime =
          el.srcElement.parentElement.parentElement.querySelector(
            ".form-field-time"
          );

        if (el.target.checked) {
          fieldTime.classList.add("hidden");
        } else {
          fieldTime.classList.remove("hidden");
        }
      });
    });
  }

  if (customTime) {
    // add global listeners
    window.addEventListener("click", handleTime, false);
  } else {
    // remove global listeners
    window.removeEventListener("click", handleTime, false);
  }

  function handleTime(el) {
    el.stopPropagation();
    const customPopup = document.querySelector("#custom-popup");
    const isCustomClock = el.target.classList.contains("custom-clock");
    const isCustomCalendar = el.target.classList.contains("custom-calendar");
    const isPopup = el.target.getAttribute("data-target");

    if (customPopup && isCustomClock) {
      closeCurrentPopup(customPopup);
      el.stopPropagation();
    } else if (customPopup && !isPopup) {
      closeCurrentPopup(customPopup);
      el.stopPropagation();
      return;
    }

    if (
      isCustomClock ||
      el.target.getAttribute("type") === "hours" ||
      el.target.getAttribute("type") === "minutes"
    ) {
      if (!isPopup) {
        const popupEl = document.createElement("div");
        const hourEl = document.createElement("p");
        const hourTable = document.createElement("table");
        const minutesEl = document.createElement("p");
        const minutesTable = document.createElement("table");
        const time = el.target.querySelector(".hour");
        const minute = el.target.querySelector(".minute");

        popupEl.setAttribute("id", "custom-popup");
        popupEl.setAttribute("data-target", "popup");

        hourEl.textContent = "Hours";
        hourEl.setAttribute("data-target", "popup");
        popupEl.appendChild(hourEl);

        setTableRow(hourTable, options.hours, "hours", time.textContent);
        popupEl.appendChild(hourTable);

        minutesEl.textContent = "Minutes";
        minutesEl.setAttribute("data-target", "popup");
        popupEl.appendChild(minutesEl);

        setTableRow(
          minutesTable,
          options.minutes,
          "minutes",
          minute.textContent
        );
        popupEl.appendChild(minutesTable);

        el.target.appendChild(popupEl);
      } else if (isPopup && el.target.hasAttribute("type")) {
        const popupEl = document.querySelector("#custom-popup");
        const type = el.target.getAttribute("type");
        const time = popupEl.parentElement.querySelector(".hour");
        const minute = popupEl.parentElement.querySelector(".minute");
        const input = popupEl.parentElement.querySelector(
          ".custom-clock-value"
        );

        clearTableValues(el.target.parentElement.parentElement);

        if (type === "hours") {
          time.innerText = el.target.textContent;
          el.target.classList.add("active");
        } else if (type === "minutes") {
          minute.innerText = el.target.textContent;
          el.target.classList.add("active");
        }

        const convertTime = `${time.textContent}:${minute.textContent}`;
        input.value = convertTime;
      }
    }

    if (
      isCustomCalendar ||
      el.target.getAttribute("type") === "month" ||
      el.target.getAttribute("type") === "day"
    ) {
      if (!isPopup) {
        const popupEl = document.createElement("div");
        const monthEl = document.createElement("p");
        const monthItems = document.createElement("ul");
        const dayEl = document.createElement("p");
        const daysTable = document.createElement("table");
        const dateStart = el.target.parentElement.querySelector(".date-start");
        const dateEnd = el.target.parentElement.querySelector(".date-end");

        monthItems.classList.add("custom-calendar-popup-list");
        popupEl.classList.add("custom-calendar-popup");
        popupEl.setAttribute("id", "custom-popup");
        popupEl.setAttribute("data-target", "popup");

        monthEl.textContent = "Months";
        popupEl.appendChild(monthEl);

        months.map((m, i) => {
          const monthItem = document.createElement("li");
          monthItem.textContent = m.short;
          monthItem.setAttribute("data-target", "popup");
          monthItem.setAttribute("data-index", i);
          monthItem.setAttribute("type", "month");

          if (
            !isNaN(new Date(dateStart.value).valueOf())
              ? i === new Date(dateStart.value).getMonth()
              : i === new Date().getMonth()
          ) {
            monthItem.classList.add("active");
          }

          monthItems.appendChild(monthItem);
        });

        popupEl.appendChild(monthItems);

        dayEl.textContent = "Days";
        popupEl.appendChild(dayEl);

        setTableRowDate(
          daysTable,
          monthArray[
            !isNaN(new Date(dateStart.value).valueOf())
              ? new Date(dateStart.value).getMonth()
              : new Date().getMonth()
          ].weeksArray,
          dateStart.value,
          dateEnd.value
        );
        popupEl.appendChild(daysTable);

        el.target.appendChild(popupEl);
      } else if (isPopup && el.target.hasAttribute("type")) {
        const monthIdx = el.target.getAttribute("data-index");
        const dateStart =
          customPopup.parentElement.querySelector(".date-start");
        const dateEnd = customPopup.parentElement.querySelector(".date-end");
        const type = el.target.getAttribute("type");
        const dateStartText =
          customPopup.parentElement.querySelector(".date-start-text");
        const dateEndText =
          customPopup.parentElement.querySelector(".date-end-text");

        if (type === "month") {
          clearUlValues(el.target.parentElement.childNodes);
          el.target.classList.add("active");
          updateTable(customPopup, monthIdx, dateStart.value, dateEnd.value);
        } else if (type === "day") {
          if (dateStart.value && dateEnd.value) {
            dateStart.value = null;
            dateEnd.value = null;
            dateStartText.innerText = "--";
            dateEndText.innerText = "--";

            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd"
            )}`;
            dateStart.value = el.target.getAttribute("data-date");
            updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          } else if (!dateStart.value) {
            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd"
            )}`;
            dateStart.value = el.target.getAttribute("data-date");

            updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          } else if (
            !dateEnd.getAttribute("data-day") &&
            new Date(el.target.getAttribute("data-date")).getTime() >
              new Date(dateStart.value).getTime()
          ) {
            dateEndText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd"
            )}`;
            dateEnd.value = el.target.getAttribute("data-date");

            updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          } else {
            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd"
            )}`;
            dateStart.value = el.target.getAttribute("data-date");

            updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          }
        }
      }
    }
  }

  function updateTable(element, monthIdx, start, end) {
    const daysTable = document.createElement("table");
    element.removeChild(element.querySelector("table"));
    setTableRowDate(daysTable, monthArray[monthIdx].weeksArray, start, end);
    element.appendChild(daysTable);
  }

  function closeCurrentPopup(node) {
    node.parentNode.removeChild(node);
  }

  function clearUlValues(nodes) {
    nodes.forEach((el) => {
      if (el.classList.contains("active")) {
        el.classList.remove("active");
      }
    });
  }

  function clearTableValues(el) {
    el.childNodes.forEach((el) => {
      el.childNodes.forEach((el) => {
        if (el.classList.contains("active")) {
          el.classList.remove("active");
        }
      });
    });
  }

  function setTableRow(el, numbers, type, value, secondValue) {
    var tbdy = document.createElement("tbody");
    numbers.map((row) => {
      var tr = document.createElement("tr");
      row.map((r) => {
        var td = document.createElement("td");
        if (
          (type === "hours" && value == r) ||
          (type === "minutes" && value == r)
        ) {
          td.classList.add("active");
        }

        td.setAttribute("type", type);
        td.setAttribute("data-target", "popup");
        td.appendChild(document.createTextNode(r < 10 ? "0" + r : r));
        tr.appendChild(td);
      });
      tbdy.appendChild(tr);
    });

    el.appendChild(tbdy);
  }

  function setTableRowDate(el, numbers, startDate, endDate) {
    var tbdy = document.createElement("tbody");
    numbers.map((row) => {
      var tr = document.createElement("tr");
      row.map((r) => {
        var td = document.createElement("td");
        if (r.disabled) {
          td.classList.add("disabled");
        }

        if (startDate == r.date || endDate == r.date) {
          td.classList.add("active");
        } else if (startDate < r.date && r.date < endDate) {
          td.classList.add("range");
        }

        td.setAttribute("type", "day");
        td.setAttribute("data-target", "popup");
        td.setAttribute("data-date", r.date);
        td.appendChild(document.createTextNode(r.number));
        tr.appendChild(td);
      });
      tbdy.appendChild(tr);
    });

    el.appendChild(tbdy);
  }

  // helpers
  function* range(start, end, step) {
    while (start <= end) {
      yield start;
      start += step;
    }
  }

  function getNumberMatrix(arr) {
    var rows = [];
    var currIdx = 0;
    arr.forEach((num, i) => {
      if (i % 6 === 0) {
        rows.push([]);
        currIdx++;
      }
      rows[currIdx - 1].push(num);
    });

    return rows;
  }

  function getMountMatrix({ year, mount }, convertDate = (val) => val) {
    const date = new Date(year, mount);
    const matrix = eachWeekOfInterval(
      {
        start: startOfMonth(date),
        end: endOfMonth(date),
      },
      {
        weekStartsOn: 1,
      }
    );

    return matrix.map((weekDay) =>
      eachDayOfInterval({
        start: startOfISOWeek(weekDay),
        end: endOfISOWeek(weekDay),
      }).map((day) =>
        convertDate(day, {
          isSameMonth: isSameMonth(date, day),
        })
      )
    );
  }
});
